module.exports = __webpack_public_path__ + "static/media/0024_IMG_TRAD_LES_MURS_P21_UNI_CARVAO_HORIZONTALE.e9a37441.png";